import { useTranslation } from 'react-i18next';
import ServiceLayout from './components/ServiceLayout';
import useSeoPage from '@/hooks/useSeoPage';

export default function OrthodonticsPage() {
  const { t } = useTranslation();
  const siteUrl = import.meta.env.VITE_SITE_URL ?? '';

  useSeoPage({
    title: 'Ортодонтия Кишинёв | Брекеты и элайнеры Invisalign | Zimbet32',
    description: 'Исправление прикуса в Кишинёве: металлические брекеты, Invisalign, лингвальные системы. Zimbet32 — ortodonție modernă în Chișinău pentru un zâmbet perfect.',
    keywords: 'ортодонтия Кишинёв, брекеты, Invisalign, исправление прикуса, ortodonție Chișinău, aparat dentar, Zimbet32',
    canonicalPath: '/services/orthodontics',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'MedicalProcedure',
      name: 'Ортодонтия',
      url: `${siteUrl}/services/orthodontics`,
      description: 'Ортодонтическое лечение в Кишинёве: исправление прикуса, брекеты, Invisalign, ретейнеры.',
      procedureType: 'https://schema.org/TherapeuticProcedure',
      bodyLocation: 'Зубы, прикус',
      provider: {
        '@type': 'Dentist',
        name: 'Zimbet32',
        url: siteUrl,
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Strada București 60',
          addressLocality: 'Chișinău',
          postalCode: 'MD-2012',
          addressCountry: 'MD',
        },
        telephone: '+373-22-22-07-09',
      },
    },
  });

  const procedures = [
    {
      icon: 'ri-contrast-2-line',
      title: t('servicePages.orthodontics.procedures.braces.title'),
      description: t('servicePages.orthodontics.procedures.braces.description')
    },
    {
      icon: 'ri-eye-off-line',
      title: t('servicePages.orthodontics.procedures.invisalign.title'),
      description: t('servicePages.orthodontics.procedures.invisalign.description')
    },
    {
      icon: 'ri-user-smile-line',
      title: t('servicePages.orthodontics.procedures.lingual.title'),
      description: t('servicePages.orthodontics.procedures.lingual.description')
    },
    {
      icon: 'ri-parent-line',
      title: t('servicePages.orthodontics.procedures.children.title'),
      description: t('servicePages.orthodontics.procedures.children.description')
    },
    {
      icon: 'ri-shield-line',
      title: t('servicePages.orthodontics.procedures.retainers.title'),
      description: t('servicePages.orthodontics.procedures.retainers.description')
    },
    {
      icon: 'ri-file-list-3-line',
      title: t('servicePages.orthodontics.procedures.consultation.title'),
      description: t('servicePages.orthodontics.procedures.consultation.description')
    }
  ];

  const advantages = [
    {
      icon: 'ri-emotion-happy-line',
      title: t('servicePages.orthodontics.benefits.beautiful.title'),
      description: t('servicePages.orthodontics.benefits.beautiful.description')
    },
    {
      icon: 'ri-heart-pulse-line',
      title: t('servicePages.orthodontics.benefits.health.title'),
      description: t('servicePages.orthodontics.benefits.health.description')
    },
    {
      icon: 'ri-star-line',
      title: t('servicePages.orthodontics.benefits.confidence.title'),
      description: t('servicePages.orthodontics.benefits.confidence.description')
    }
  ];

  const galleryImages = [
    'https://public.readdy.ai/ai/img_res/9ede36b095ea5fdbfd5655de0e34d32b.jpg',
    'https://readdy.ai/api/search-image?query=clear%20invisalign%20aligners%20transparent%20orthodontic%20trays%20for%20invisible%20teeth%20straightening%20displayed%20on%20white%20surface%20in%20modern%20dental%20office%20with%20professional%20lighting%20showing%20innovative%20dental%20technology&width=800&height=600&seq=ortho-invisalign-2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=before%20and%20after%20orthodontic%20treatment%20comparison%20showing%20teeth%20alignment%20transformation%20with%20straight%20beautiful%20smile%20in%20professional%20dental%20photography%20with%20clean%20white%20background%20and%20perfect%20lighting&width=800&height=600&seq=ortho-before-after-3&orientation=landscape',
    'https://readdy.ai/api/search-image?query=orthodontist%20examining%20patient%20teeth%20with%20dental%20mirror%20in%20modern%20clinic%20bright%20professional%20lighting%20showing%20doctor%20patient%20consultation%20for%20braces%20treatment%20in%20clean%20white%20medical%20environment&width=800&height=600&seq=ortho-exam-4&orientation=landscape',
    'https://readdy.ai/api/search-image?query=ceramic%20tooth%20colored%20braces%20on%20teeth%20aesthetic%20orthodontic%20treatment%20with%20white%20brackets%20in%20modern%20dental%20clinic%20professional%20photography%20with%20clean%20background%20highlighting%20cosmetic%20dentistry&width=800&height=600&seq=ortho-ceramic-5&orientation=landscape',
    'https://readdy.ai/api/search-image?query=beautiful%20straight%20white%20teeth%20smile%20after%20orthodontic%20treatment%20showing%20perfect%20alignment%20and%20healthy%20gums%20in%20bright%20modern%20dental%20office%20with%20professional%20photography%20lighting%20and%20clean%20background&width=800&height=600&seq=ortho-result-6&orientation=landscape'
  ];

  return (
    <ServiceLayout
      heroImage="https://readdy.ai/api/search-image?query=modern%20orthodontic%20clinic%20interior%20with%20dental%20chair%20advanced%20equipment%20for%20braces%20and%20invisalign%20treatment%20bright%20professional%20lighting%20clean%20white%20medical%20environment%20showing%20orthodontic%20instruments%20and%20technology&width=1920&height=600&seq=ortho-hero&orientation=landscape"
      breadcrumbKey="servicePages.orthodontics.title"
      titleKey="servicePages.orthodontics.title"
      descriptionKey="servicePages.orthodontics.description"
      procedures={procedures}
      advantages={advantages}
      galleryImages={galleryImages}
      ctaTitleKey="servicePages.orthodontics.ctaTitle"
      ctaDescriptionKey="servicePages.orthodontics.ctaDescription"
      ctaButtonKey="servicePages.orthodontics.ctaButton"
    />
  );
}
